export function inr(v) {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  const n = Number(v);
  const sign = n < 0 ? "-" : "";
  const a = Math.abs(n);
  if (a >= 1e7) return `${sign}₹${(a / 1e7).toFixed(2)} Cr`;
  if (a >= 1e5) return `${sign}₹${(a / 1e5).toFixed(2)} L`;
  return `${sign}₹${a.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
}

export function pct(v, digits = 1) {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  return `${Number(v).toFixed(digits)}%`;
}

export function num(v) {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  return Number(v).toLocaleString("en-IN", { maximumFractionDigits: 2 });
}

export function score(v) {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  return Number(v).toFixed(1);
}

export const THEME_LABELS = {
  health: "Health & Nutrition",
  education: "Education & Skilling",
  livelihoods: "Livelihoods & Rural Development",
  environment: "Environment & Sustainability",
  heritage: "Art, Culture & Heritage",
  sports: "Sports",
  other: "Other / Unclassified",
};

export const CHART_COLORS = ["#0284C7", "#0F2942", "#059669", "#D97706", "#4F46E5", "#E11D48"];
